
export const LOAD_ACCESS_CODE_DATA_IN_PROGRESS = "LOAD_ACCESS_CODE_DATA_IN_PROGRESS";
export const loadAccessCodeDataInProgress = () => ({
  type: LOAD_ACCESS_CODE_DATA_IN_PROGRESS,
});

export const LOAD_ACCESS_CODE_DATA_SUCCESS = "LOAD_ACCESS_CODE_DATA_SUCCESS";
export const loadAccessCodeDataSuccess = (data) => ({
  type: LOAD_ACCESS_CODE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_ACCESS_CODE_DATA_FAILURE = "LOAD_ACCESS_CODE_DATA_FAILURE";
export const loadAccessCodeDataFailure = () => ({
  type: LOAD_ACCESS_CODE_DATA_FAILURE,
});

export const ACCESS_CODE_CREATION_COMPLETED = "ACCESS_CODE_CREATION_COMPLETED";
export const accessCodeCreationCompleted = () => ({
  type: ACCESS_CODE_CREATION_COMPLETED,
});

export const OPEN_ACCESS_CODE_DIALOG = "OPEN_ACCESS_CODE_DIALOG";
export const openAccessCodeDialog = () => ({
  type: OPEN_ACCESS_CODE_DIALOG,
});

export const CLOSE_ACCESS_CODE_DIALOG = "CLOSE_ACCESS_CODE_DIALOG";
export const closeAccessCodeDialog = () => ({
  type: CLOSE_ACCESS_CODE_DIALOG,
});

export const LOAD_ACCESS_CODE_LOGIN_USERNAME_SUCCESS = "LOAD_ACCESS_CODE_LOGIN_USERNAME_SUCCESS";
export const loadAccessCodeLoginUsernameSuccess = (data) => ({
  type: LOAD_ACCESS_CODE_LOGIN_USERNAME_SUCCESS,
  payload: { data },
});

export const LOAD_ACCESS_CODE_LOGIN_USERNAME_CLEAR = "LOAD_ACCESS_CODE_LOGIN_USERNAME_CLEAR";
export const loadAccessCodeLoginUsernameClear = () => ({
  type: LOAD_ACCESS_CODE_LOGIN_USERNAME_CLEAR,
});